export const FETCH_TEACHER_ASSIGN = "FETCH_TEACHER_ASSIGN";
export const FETCH_TEACHER_ASSIGN_SUCCESS = "FETCH_TEACHER_ASSIGN_SUCCESS";
export const FETCH_TEACHER_ASSIGN_ERROR = "FETCH_TEACHER_ASSIGN_ERROR";
export const UPDATE_TEACHER_ASSIGN = "UPDATE_TEACHER_ASSIGN";
export const UPDATE_TEACHER_ASSIGN_SUCCESS = "UPDATE_TEACHER_ASSIGN_SUCCESS";
export const UPDATE_TEACHER_ASSIGN_ERROR = "UPDATE_TEACHER_ASSIGN_ERROR";
export const CREATE_TEACHER_ASSIGN = "CREATE_TEACHER_ASSIGN";
export const CREATE_TEACHER_ASSIGN_SUCCESS = "CREATE_TEACHER_ASSIGN_SUCCESS";
export const CREATE_TEACHER_ASSIGN_ERROR = "CREATE_TEACHER_ASSIGN_ERROR";
export const IS_ADDING_UPDATE = "IS_ADDING_UPDATE_STICKER";
export const SET_TEACHER_MANAGER_STATE = "SET_TEACHER_MANAGER_STATE";
